import { startTransition, useEffect } from "react";

import { useContentSelectors } from "../store/content/content.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useCountries = lang => {
  const { country } = useContentSelectors();
  const { getAllCountries } = useDispatchedActions();

  useEffect(() => {
    if (!country[lang]) {
      startTransition(() => getAllCountries(lang));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);
};
